

import React, { useState } from "react";
import { Grid, Typography, Box, Tab, Tabs, Button,  Link, } from "@mui/material";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import BottomNavigation from '@mui/material/BottomNavigation';
import { useNavigate } from "react-router-dom";

import { Form, Formik } from "formik";
import * as Yup from "yup";

import AiImage from "../../assets/images/AiImage.svg";
import summaryService from "../../services/summary";
import CustomizedSnackbars from "../../component/Snackbar/Index";
import Footer from "../../component/Footer/Footer";


const Password = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbarTitle, setOpenSnackbarTitle] = useState("");

  const handleFormSubmit = async (value) => {
  
    try {
      const response = await summaryService.postForgotPassword(value);
      if (response.ok) {
        setOpenSnackbar(true);
        setOpenSnackbarTitle(response.data);
      }
      else {
        if (Object.keys(response?.data).length > 0) {
          setOpenSnackbar(true);
          setOpenSnackbarTitle(response?.data?.error);
        } else {
          setOpenSnackbar(true);
          setOpenSnackbarTitle("Some thing went wrong");
        }
      }
      
    } catch (error) {
      console.log(error);
     
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          email: "",
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .required("Email is Required")
            .email()
            .trim()
            .label("Email"),

          // .matches(
          //   /^.*(?=.{6,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
          //   "The password must contain 8 characters, one upper case, one number and one special case character"
          // )
        })}
        onSubmit={(values) => {
          handleFormSubmit(values)
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          values,
          touched,
          setFieldValue,
          getFieldProps,
        }) => (
          <Form>
            <Grid container sx={{mt:"5rem",mb:"3rem"}}>
              {/* <Grid
                xs={12}
                sx={{ background: "#caf0f8", padding: "3rem", height: "200px" }}
              /> */}
              <Grid xs={12} textAlign="center" className={classes.logoAlign}>
                <Box
                  sx={{
                    display: "flex",
                    padding: "1rem",
                    justifyContent: "center",
                  }}
                  
                >
                  <img
                    src={AiImage}
                    alt="AiImage"
                    width="250px"
                    height="auto"
                    style={{cursor: "pointer"}}
                    onClick={() => navigate("/login")}
                  />
                </Box>
              </Grid>
              <Grid xs={12} className={classes.loginBlock}>
                <Box className={classes.contentBlock}>
               
                <Typography variant="h3" gutterBottom>
                       Forgot Password?
                      </Typography>
                      <Typography variant="subtitel2" gutterBottom>
                      Enter the email address associated with your account
                      </Typography>
                  <Box mt={2.5}>
                    <TextField
                      type="email"
                      name="email"
                      value="email"
                    
                      className={classes.textFieldWidth}
                      label="Email*"
                      {...getFieldProps("email")}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MailOutlineIcon sx={{ fontSize: "18px" }} />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </Box>
                  <Typography mt={2} textAlign="right">
                    Remember your password?
                    <Link
                      onClick={() => navigate("/login")}
                      className={classes.login}
                    >
                      {" "}
                      Login
                    </Link>
                  </Typography>
                  <Box mt={1.5}>
                    <Button
                      className={classes.textFieldWidth}
                      variant="contained"
                      type="submit"
                    >
                     submit
                    </Button>
                  </Box>
                
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
     <BottomNavigation>
     <Footer />
     </BottomNavigation>

      <CustomizedSnackbars
        open={openSnackbar}
        close={() => setOpenSnackbar(false)}
        title={openSnackbarTitle}
      />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  logoAlign: {
    display: "block !important",
   
  },
  login: {
    textDecoration: "none",
    cursor: "pointer",
  },
  boxAlign: {
    display: "flex",
    padding: "4rem 3rem",
    [theme.breakpoints.down("md")]: {
      padding: "4rem 2rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "4rem 1rem",
    },
  },
  textFieldWidth: {
    width: "370px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  loginBlock: {
    display: "flex",
    justifyContent: "center",
    margin: "auto",
    marginTop: "1rem",
  },
  contentBlock: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
    opacity: 1,
    marginBottom:"3rem",
    padding: "1rem 2rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0rem 1rem",
    },
  },
  signIn: {
    fontWeight: "bold",
    textAlign: "center",
    color: "orange",
    marginTop: "1rem",
    lineHeight: 1.5,
    letterSpacing: "1px",
    cursor: "pointer",
  },
}));

export default Password;
